import React, {useCallback, useEffect, useState} from "react";
import PropTypes, {InferProps} from "prop-types";
import {sessionProject, usePrincipal, useProject} from "@betrue/front/services";
import {Product} from "@betrue/shared/interfaces";
import {ProductButtonView} from "./product-button.view";

export const ProductButtonPropsTypes = {
  dynamicButtonAddLabel: PropTypes.string,
  dynamicButtonDeleteLabel: PropTypes.string,
  dynamicButtonKey: PropTypes.string,
  dynamicButtonValue: PropTypes.string,
  offlineNotice: PropTypes.string,
  startingPriceLabel: PropTypes.string,
  maxPrice: PropTypes.string,
  minPrice: PropTypes.string,
}
export type ProductButtonProps = InferProps<typeof ProductButtonPropsTypes>

export const ProductButton = (props: ProductButtonProps) => {
  const [principal] = usePrincipal()
  const [project, , {createProject, addProduct, deleteProduct}] = useProject(sessionProject)
  const [triggerAddProduct, setTriggerAddProduct] = useState<boolean>(false)
  const [productToAdd, setProductToAdd] = useState<Product>(null)

  useEffect(() => {
    if (project.id && triggerAddProduct && productToAdd) {
      addProduct(project.id, productToAdd)
      setProductToAdd(null)
      setTriggerAddProduct(false)
    }
  }, [triggerAddProduct, project, productToAdd])


  const handleOnAddProduct = useCallback((product: Product) => {
    if (!project.id) {
      createProject({...project, owners: [].concat([principal], project.owners)})
      setTriggerAddProduct(true)
      setProductToAdd(product)
    } else {
      setTriggerAddProduct(true)
      setProductToAdd(product)
    }
  }, [project, principal])

  const handleDeleteProduct = useCallback((p: Product) => {

    if (project.id) {
      deleteProduct(project.id, p.id)
    }
  }, [project])

  if (!project) return (<>...</>)

  return (<ProductButtonView {...props}
                             principal={principal}
                             deleteProduct={handleDeleteProduct}
                             project={project}
                             addProduct={handleOnAddProduct}/>)
}


ProductButton.propTypes = ProductButtonPropsTypes
